var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Add as AddIcon, LocationOn as LocationOnIcon, } from "@mui/icons-material";
import { Avatar, Box, Card, CardContent, Chip, Divider, IconButton, Stack, Typography, } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { ManageButton } from "../utils/CardActions";
export var VenuesCard = function (_a) {
    var venues = _a.venues, canModify = _a.canModify, title = _a.title, manageUrl = _a.manageUrl, _b = _a.emptyStateDescription, emptyStateDescription = _b === void 0 ? "Configure your team's home venues" : _b, _c = _a.linkable, linkable = _c === void 0 ? true : _c;
    var navigate = useNavigate();
    var handleCreateClick = function () {
        navigate(manageUrl);
    };
    return (_jsx(Card, { children: _jsxs(CardContent, { children: [_jsxs(Box, { sx: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        mb: 2,
                    }, children: [_jsxs(Box, { sx: { display: "flex", alignItems: "center", gap: 1 }, children: [_jsx(Typography, { variant: "h6", sx: { fontWeight: 600 }, children: title }), venues.length > 0 && (_jsx(Chip, { label: venues.length, size: "small", sx: {
                                        backgroundColor: "rgba(25, 118, 210, 0.1)",
                                        color: "primary.main",
                                        fontWeight: 600,
                                        minWidth: 24,
                                    } }))] }), canModify && _jsx(ManageButton, { to: manageUrl })] }), _jsx(Divider, { sx: { mb: 2 } }), _jsx(Stack, { spacing: 0, children: venues.length > 0 ? (venues.map(function (venue, index) {
                        var content = (_jsxs(Box, { sx: __assign(__assign({ p: 2.5, display: "flex", alignItems: "center" }, (linkable && {
                                "&:hover": {
                                    backgroundColor: "#f8f9ff",
                                    transform: "translateX(2px)",
                                },
                            })), { transition: "all 0.2s ease", borderBottom: index < venues.length - 1
                                    ? "1px solid rgba(0,0,0,0.08)"
                                    : "none" }), children: [_jsx(Avatar, { sx: {
                                        width: 40,
                                        height: 40,
                                        backgroundColor: "rgba(25, 118, 210, 0.1)",
                                        color: "primary.main",
                                    }, children: _jsx(LocationOnIcon, {}) }), _jsxs(Box, { sx: { ml: 2 }, children: [_jsx(Typography, { variant: "body1", sx: { fontWeight: 600, mb: 0.5 }, children: venue.name }), venue.formattedAddress && (_jsx(Typography, { variant: "caption", sx: {
                                                color: "text.secondary",
                                                display: "block",
                                            }, children: venue.formattedAddress }))] })] }, linkable ? undefined : venue.id));
                        return linkable ? (_jsx(Link, { to: "/venues/".concat(venue.id, "/"), style: { textDecoration: "none", color: "inherit" }, children: content }, venue.id)) : (content);
                    })) : (_jsxs(Box, { sx: { p: 4, textAlign: "center" }, children: [_jsx(Avatar, { sx: {
                                    width: 56,
                                    height: 56,
                                    backgroundColor: "rgba(25, 118, 210, 0.1)",
                                    color: "primary.main",
                                    mx: "auto",
                                    mb: 2,
                                }, children: _jsx(LocationOnIcon, { sx: { fontSize: 28 } }) }), _jsx(Typography, { variant: "h6", color: "text.secondary", sx: { mb: 1 }, children: "No home pitch yet" }), canModify && (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 2 }, children: emptyStateDescription }), _jsx(IconButton, { onClick: handleCreateClick, role: "button", sx: {
                                            backgroundColor: "primary.main",
                                            color: "white",
                                            "&:hover": {
                                                backgroundColor: "primary.dark",
                                                transform: "scale(1.05)",
                                            },
                                            transition: "all 0.2s ease",
                                        }, children: _jsx(AddIcon, {}) })] }))] })) })] }) }));
};
